import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { Products } from "../../pages/ProductPage/ProductPage";
import { useCart } from "../CartContext/CartContext";
import { Loader2 } from "lucide-react";
import SecondaryButton from "../Button/SecondaryButton";
import PrimaryButtonButton from "../Button/PrimaryButton";

interface CartModalProps {
  isCartModalVisible: boolean;
  setIsCartModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  addedProduct: Products | null;
  color?: string;
  handleIncrease: () => void;
  handleDecrease: () => void;
  availableStock: number | null;
  isIncreasing?: boolean;
  setIsIncreasing?: (isIncreasing: boolean) => void;
  quantity: number;
  isUpdating: boolean;
  isDecreasing: boolean;
  setAvailableStock?: (isIncreasing: number) => void;
  setPrinciple?: (value: string) => void;
  isBlack?: boolean;
  isMachine?: boolean;
  stock?: number;
}

const CartModal: React.FC<CartModalProps> = ({
  isCartModalVisible,
  setIsCartModalVisible,
  addedProduct,
  handleIncrease,
  handleDecrease,
  availableStock,
  color,
  quantity,
  isUpdating,
  isDecreasing,
  setAvailableStock,
  setPrinciple,
  isBlack,
  isMachine,
  stock,
}) => {
  const navigate = useNavigate();
  const { cart, fetchStockForAllItems } = useCart();
  const [totalPrice, setTotalPrice] = useState<number>(0);

  useEffect(() => {
    if (addedProduct) {
      const calculatedTotal = addedProduct.price * (addedProduct.item_quantity || 0);
      setTotalPrice(calculatedTotal);
    }
  }, [addedProduct, addedProduct?.item_quantity]);

  useEffect(() => {
    const existingItem = cart.find(
      (item) => item.id === addedProduct?.id && item.color === color
    );
    if (existingItem) {

    }
  }, [addedProduct, color, cart]);

  const isOutOfStock = (availableStock || 0) <= 0;

  useEffect(() => {
    if (!isCartModalVisible) {
      if (setAvailableStock && setPrinciple) {
        setAvailableStock(0);
        setPrinciple("");
      }
    }
  }, [isCartModalVisible, setAvailableStock, setPrinciple]);

  const getImageSource = () => {
    return addedProduct?.image;
  };

  return (
    <Modal
      open={isCartModalVisible}
      onCancel={() => setIsCartModalVisible(false)}
      footer={null}>
      {addedProduct && (
        <div className="" onClick={() => setIsCartModalVisible(false)}>
          <div className="bg-white" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center space-x-6 mb-6">
              <div className="relative">
                <img
                  className="w-24 h-24 object-contain rounded-lg"
                  src={getImageSource()}
                  alt={addedProduct.name}
                />
              </div>

              <div className="flex-grow">
                <h2 className="text-xl font-bold text-[#005D6E] mb-2">
                  {addedProduct.name}
                </h2>
                <p className="text-gray-700 mb-1">
                  <span className="font-semibold">Price:</span> R
                  {addedProduct.price}
                </p>
                <p className="text-gray-700 font-semibold">
                  <span>Total: </span>R{totalPrice.toFixed(2)}
                </p>
              </div>
            </div>

            <div className="mb-6">
              <div className="flex items-center justify-between">
                <span className="text-gray-700 font-semibold">Quantity</span>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={handleDecrease}
                    disabled={isDecreasing || (availableStock || 0) <= 0}
                    className="w-10 h-10 rounded-full flex items-center justify-center border border-gray-300 hover:bg-gray-100">
                    {isDecreasing ? (
                      <Loader2 className="w-4 h-4 animate-spin" />
                    ) : (
                      "-"
                    )}
                  </button>
                  <span
                    className={`text-lg font-bold ${
                      isOutOfStock ? "text-gray-400" : ""
                    }`}>
                    {addedProduct.item_quantity || 0}
                  </span>
                  <button
                    onClick={handleIncrease}
                    disabled={isUpdating || (availableStock || 0) <= 0}
                    className="w-10 h-10 rounded-full flex items-center justify-center border border-gray-300 hover:bg-gray-100">
                    {isUpdating ? (
                      <Loader2 className="w-4 h-4 animate-spin" />
                    ) : (
                      "+"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="flex space-x-4">
        <PrimaryButtonButton   onClick={() => setIsCartModalVisible(false)} label="Continue Shopping" />
       

        <SecondaryButton
          onClick={() => {
            setIsCartModalVisible(false);
            navigate("/cart");
            fetchStockForAllItems();
          }}
          label="View Cart"
          className="flex-1 py-3 hover:bg-[#00414C] text-white"
        />
      </div>
    </Modal>
  );
};

export default CartModal;